<div class="workflow-grid-container">
  <div class="panel-header">
    <h3>{{ title }}</h3>
    <div class="header-actions">
      <button type="button" class="refresh-btn" (click)="refresh()">Refresh</button>
      <button type="button" class="cancel-btn" (click)="cancel()">Close</button>
    </div>
  </div>
  <div class="panel-body">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
      <span>Loading workflow grid...</span>
    </div>
}
    @if (!loading && errorMessage) {
<div class="alert alert-error">{{ errorMessage }}</div>
}
    @if (!loading && !errorMessage && gridPayload) {
<div class="grid-wrapper">
      @if (gridColumns.length > 0) {
<table class="table table-bordered form-inline custom-table">
        <thead>
          <tr>
            @for (col of gridColumns; track $index) {
<th>{{ col }}</th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of gridRows; track $index) {
<tr>
            @for (col of gridColumns; track $index) {
<td>{{ row[col] }}</td>
}
          </tr>
}
        </tbody>
      </table>
}
      @if (gridColumns.length === 0 && gridRows.length === 0) {
<p class="no-data">No records to display.</p>
}
    </div>
}
  </div>
</div>
